<form
    [attr.role]="'search'"
    [formGroup]="searchLocationForm"
    (ngSubmit)="searchLocationSubmit()"
    [class.force-inline]="forceInlineDisplay"
    [class.small-cta]="ctaSize === 'small'"
    class="search-location-form">
    <div class="search-location-input">
        <div
            [attr.role]="'combobox'"
            [attr.aria-haspopup]="'listbox'"
            [attr.aria-controls]="'search-location'"
            [attr.aria-owns]="
                (hasSuggestions$ | async) === true && (showSuggestions$ | async) === true ? 'search-input' : undefined
            "
            class="search-combobox-element"
            [attr.aria-expanded]="true">
            <h-search-input
                [attr.data-testid]="'places-search-bar-input'"
                [controlName]="'searchInput'"
                [id]="searchInputId"
                [name]="'search-location'"
                [autocomplete]="'off'"
                [ariaAutoComplete]="'list'"
                [ariaControls]="'search-input'"
                label="Find a place"
                i18n-label="@@page--hermes-global--find-store.value-label"
                placeholder="Address, city, zip code..."
                i18n-placeholder="@@hermes.commerce.product_locator.search.placeholder"
                [errorManagement]="false"
                [showSuggestions$]="showSuggestions$"
                (handleKeyDown)="handleKeyDown($event)"
                [showClearButton]="(showClearButton$ | async) === true && searchLocationForm.enabled"
                [hasRightIcon]="(showGeolocalization$ | async) === true"
                (selectNewSuggestion)="selectNewSuggestion($event)">
                @if (countryError) {
                    <ng-container errors>
                        <h-message-block
                            [attr.data-testid]="'places-search-bar-address-error'"
                            [type]="'error'"
                            [showBackground]="false"
                            [autoAddPadding]="false"
                            >{{ unknownPlaceMessage }}
                        </h-message-block>
                    </ng-container>
                }
                @if (geolocationError) {
                    <ng-container errors>
                        <h-message-block
                            [attr.data-testid]="'places-search-bar-geolocation-error'"
                            [type]="'error'"
                            [showBackground]="false"
                            [autoAddPadding]="false">
                            <ng-container i18n="@@hermes.catalog.product_pages.find-in-store-error-service-unavailable">
                                Something went wrong. Fear not, we will be right back.
                            </ng-container>
                        </h-message-block>
                    </ng-container>
                }
                @for (suggestion of suggestions$ | async; track suggestion) {
                    <ng-template #hSearchInputSuggestion>
                        <div class="search-location-suggestion">
                            <span>
                                <h-svg-icon [name]="'pin-dark'"></h-svg-icon>
                                <span class="suggestion-area-text">
                                    <span hSrOnlyNoSnippet
                                        >{{ suggestion.mainText }} {{ suggestion.secondaryText }}</span
                                    >
                                    <span [attr.aria-hidden]="'true'" class="pl-suggestion-main-text">
                                        <strong>{{
                                            getMainTextFirstPart(
                                                suggestion.mainText,
                                                suggestion.matchedSubstringPosition
                                            )
                                        }}</strong>
                                        <span>{{
                                            getMainTextSecondPart(
                                                suggestion.mainText,
                                                suggestion.matchedSubstringPosition
                                            )
                                        }}</span>
                                    </span>
                                    <span [attr.aria-hidden]="'true'" class="suggestion-secondary-text paragraph-small">
                                        {{ suggestion.secondaryText }}</span
                                    >
                                </span>
                            </span>
                        </div>
                    </ng-template>
                }
            </h-search-input>
        </div>
        <ng-content></ng-content>
        @if ((showClearButton$ | async) !== true) {
            <button
                type="button"
                class="geolocalization-button"
                [disabled]="searchLocationForm.disabled"
                (click)="getLocation('user')">
                <h-svg-icon [name]="'geolocalization'" class="icon-button"></h-svg-icon>

                <span hSrOnlyNoSnippet i18n="@@page--hermes-global--find-store.use-my-current-location">
                    Use my current location
                </span>
            </button>
        }
    </div>

    <h-call-to-action
        class="search-location-button"
        [disabled]="searchLocationForm.disabled"
        [type]="'submit'"
        [dataTestId]="'Find'"
        i18n="@@page--hermes-global--find-store.find">
        Find
    </h-call-to-action>
</form>
